<h2 mat-dialog-title>Histórico de Reportes</h2>

<mat-dialog-content>
  <div *ngFor="let reporte of reportes; let i = index" class="reporte-item">
    <div class="reporte-header">
      <span *ngIf="mostrarIndice" class="reporte-numero">#{{ i + 1 }}</span>
      <span class="status-badge" [ngClass]="getStatusClass(reporte.status)">{{ getStatusLabel(reporte.status) }}</span>
    </div>

    <div class="reporte-row">
      <div class="reporte-field">
        <span class="field-label">Reportado por:</span>
        <span *ngIf="reporte.nomeReportador && reporte.nomeReportador !== reporte.reportadoPor">{{ reporte.nomeReportador }} - {{ reporte.reportadoPor }} ({{ getTipoReportadorLabel(reporte.tipoReportador) }})</span>
        <span *ngIf="!reporte.nomeReportador || reporte.nomeReportador === reporte.reportadoPor">{{ reporte.reportadoPor }} ({{ getTipoReportadorLabel(reporte.tipoReportador) }})</span>
      </div>
      <div class="reporte-field">
        <span class="field-label">Data:</span>
        <span>{{ reporte.reportadoEm | date : 'dd/MM/yyyy HH:mm' }}</span>
      </div>
    </div>
    <div class="reporte-field" *ngIf="reporte.justificativaReporte">
      <span class="field-label">Motivo da suspeita:</span>
      <span class="field-value-block">{{ reporte.justificativaReporte }}</span>
    </div>

    <div *ngIf="reporte.decididoPor" class="reporte-decisao">
      <div class="reporte-row">
        <div class="reporte-field">
          <span class="field-label">Decidido por:</span>
          <span *ngIf="reporte.nomeDecididor && reporte.nomeDecididor !== reporte.decididoPor">{{ reporte.nomeDecididor }} - {{ reporte.decididoPor }} (Presidente)</span>
          <span *ngIf="!reporte.nomeDecididor || reporte.nomeDecididor === reporte.decididoPor">{{ reporte.decididoPor }} (Presidente)</span>
        </div>
        <div class="reporte-field">
          <span class="field-label">Data da decisão:</span>
          <span>{{ reporte.decididoEm | date : 'dd/MM/yyyy HH:mm' }}</span>
        </div>
      </div>
      <div class="reporte-field" *ngIf="reporte.justificativaDecisao">
        <span class="field-label">Justificativa:</span>
        <span class="field-value-block">{{ reporte.justificativaDecisao }}</span>
      </div>
    </div>

    <hr *ngIf="i < reportes.length - 1" class="reporte-divider">
  </div>
  <div *ngIf="isPresidente && temPendente" class="alerta-reporte">
    <mat-icon>announcement</mat-icon>
    <span>Para resolver esta pendência, clique no botão de visualizar prova (<mat-icon class="inline-icon">visibility</mat-icon>) e escolha a opção adequada.</span>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button mat-dialog-close>Fechar</button>
</mat-dialog-actions>
